// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPermissionDto } from './IPermissionDto';
import {
    IPermissionDtoFromJSON,
    IPermissionDtoFromJSONTyped,
    IPermissionDtoToJSON,
    IPermissionDtoToJSONTyped,
} from './IPermissionDto';

/**
 * 
 * @export
 * @interface IRoleResponseDto
 */
export interface IRoleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IRoleResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRoleResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRoleResponseDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IRoleResponseDto
     */
    level_type?: IRoleResponseDtoLevelTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRoleResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRoleResponseDto
     */
    organization_name?: string;
    /**
     * 
     * @type {Set<IPermissionDto>}
     * @memberof IRoleResponseDto
     */
    granted_permissions?: Set<IPermissionDto>;
    /**
     * 
     * @type {Set<IPermissionDto>}
     * @memberof IRoleResponseDto
     */
    not_granted_permissions?: Set<IPermissionDto>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleResponseDto
     */
    role_ids_allowed_for_creation?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleResponseDto
     */
    allowed_for_creation_by_role_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IRoleResponseDto
     */
    org_properties_state_config_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IRoleResponseDtoLevelTypeEnum {
    ELEVATE = 'ELEVATE',
    GLOBAL = 'GLOBAL',
    PARTNER = 'PARTNER'
}


/**
 * Check if a given object implements the IRoleResponseDto interface.
 */
export function instanceOfIRoleResponseDto(value: object): value is IRoleResponseDto {
    return true;
}

export function IRoleResponseDtoFromJSON(json: any): IRoleResponseDto {
    return IRoleResponseDtoFromJSONTyped(json, false);
}

export function IRoleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRoleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'level_type': json['level_type'] == null ? undefined : json['level_type'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'granted_permissions': json['granted_permissions'] == null ? undefined : (new Set((json['granted_permissions'] as Array<any>).map(IPermissionDtoFromJSON))),
        'not_granted_permissions': json['not_granted_permissions'] == null ? undefined : (new Set((json['not_granted_permissions'] as Array<any>).map(IPermissionDtoFromJSON))),
        'role_ids_allowed_for_creation': json['role_ids_allowed_for_creation'] == null ? undefined : new Set(json['role_ids_allowed_for_creation']),
        'allowed_for_creation_by_role_ids': json['allowed_for_creation_by_role_ids'] == null ? undefined : new Set(json['allowed_for_creation_by_role_ids']),
        'org_properties_state_config_id': json['org_properties_state_config_id'] == null ? undefined : json['org_properties_state_config_id'],
    };
}

export function IRoleResponseDtoToJSON(json: any): IRoleResponseDto {
    return IRoleResponseDtoToJSONTyped(json, false);
}

export function IRoleResponseDtoToJSONTyped(value?: IRoleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'level_type': value['level_type'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'granted_permissions': value['granted_permissions'] == null ? undefined : (Array.from(value['granted_permissions'] as Set<any>).map(IPermissionDtoToJSON)),
        'not_granted_permissions': value['not_granted_permissions'] == null ? undefined : (Array.from(value['not_granted_permissions'] as Set<any>).map(IPermissionDtoToJSON)),
        'role_ids_allowed_for_creation': value['role_ids_allowed_for_creation'] == null ? undefined : Array.from(value['role_ids_allowed_for_creation'] as Set<any>),
        'allowed_for_creation_by_role_ids': value['allowed_for_creation_by_role_ids'] == null ? undefined : Array.from(value['allowed_for_creation_by_role_ids'] as Set<any>),
        'org_properties_state_config_id': value['org_properties_state_config_id'],
    };
}

